/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, NgZone } from '@angular/core';
import { LoginService } from './login.service';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../shared/services/common.service';
import { COMMON_UMS, LOGIN_UMS } from '../../config/userMessages_en';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { COMPANY_CODES } from 'app/config/constants';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AboutModalComponent } from '../../shared/about-modal/about-modal.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('loginForm') loginForm!: NgForm;
  public login: any = {};
  public forgotForm = false;
  public email: any = {};
  public user: any;
  private sub: any;
  public timeZoneInfo: any;
  public isformLogin: any = null;
  public enableOtp: any = null;

  constructor(private loginService: LoginService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private router: Router,
    private zone: NgZone,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private modalService: BsModalService) {
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  ngOnInit() {
    this.translate.use('en_us');
    this.sub = this.route.params.subscribe(params => {
      if (window.location.href.match('login')) {
        const userLanguage: any = localStorage.getItem('userLanguage');
        const lastUrl = localStorage.getItem('unAuthorizedURL');
        localStorage.clear();
        localStorage.setItem('systemLogout', 'true');
        if (lastUrl === null || lastUrl === 'null') {
          localStorage.removeItem('unAuthorizedURL');
        } else {
          localStorage.setItem('unAuthorizedURL', lastUrl);
        }
        localStorage.setItem('userLanguage', userLanguage);

        this.loginService.setUser('');
        this.forgotForm = false;
        this.commonService.loadTranslations();
      } else {
        this.forgotForm = true;
      }
      this.user = this.loginService.getUser();
    });
  }

  ngAfterViewInit() { }

  private getGlobalMetadata() {
    this.commonService.fetchGlobalMetaData()
      .then((response) => {
        const res: any = response;
        res.metricsMetaData = JSON.parse(JSON.stringify(_.sortBy(res.metricsMetaData || [], 'name')));
        localStorage.setItem('globalMetaData', JSON.stringify(res))
      }, (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getHomePageMetaData() {
    this.loginService.getHomePageMetaData()
      .then(this.getHomePageMetaDataSH.bind(this), this.getHomePageMetaDataFH.bind(this));
  }

  private getHomePageMetaDataSH(response: any) {
    const res = response;
    this.loginService.setHomePages(res);
    const user = this.loginService.getUser();
    if (user) {
      const groups = user.groups,
        group = groups.length ? groups[0] : '';

      if (group) {
        const homePage = group.homePage ? group.homePage : '\home';
        const lastUnauthorizedUrl = localStorage.getItem('unAuthorizedURL');
        if (lastUnauthorizedUrl && lastUnauthorizedUrl != 'null') {
          localStorage.removeItem('unAuthorizedURL');
          this.zone.run(() => {
            this.router.navigateByUrl(lastUnauthorizedUrl);
          });
        } else {
          this.zone.run(() => {
            this.router.navigateByUrl(homePage);
          });
        }

      }
    }

  }

  private getHomePageMetaDataFH(error: any) {
    this.loginService.setHomePages([]);
    this.zone.run(() => {
      this.router.navigateByUrl('\home');
    });
  }

  public authenticateLoginDetails() {
    if (this.login.email) {
      const pattern = new RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$');
      if (!pattern.test((this.login.email).toLowerCase())) {
        this.email.error = LOGIN_UMS.login_invalid_email_format;
        return;
      } else {
        this.email.error = "";
      }

    }
    const authenicateObj: any = {};
    // fix to make sure case senstive issue of user name
    authenicateObj.username = (this.login.email).toLowerCase();
    authenicateObj.password = this.login.password;
    authenicateObj.code = this.login.code;
    //this.getLoginDetailsSH(authenicateObj);
    // this.loginService.authenticateLoginDetails(authenicateObj)
    //   .then(this.getLoginDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    this.commonService.getGlobalSettingstabType(authenicateObj)
      .then(this.getGlobalSettingsSH.bind(this), this.getGlobalSettingsFH.bind(this));
  }

  public forgotLoginDetails() {
    const forgotUserName = (this.login.forgotUserName).toLowerCase();
      this.loginService.resetPasswordDetails(forgotUserName)
        .then(this.forgotLoginDetailsSH.bind(this), this.forgotLoginDetailsFH.bind(this));
    // const companyCode: string = this.commonService.getCompanyCode();
    // if (companyCode == COMPANY_CODES.thermomixPoland) {
      // const forgotUserName = (this.login.forgotUserName).toLowerCase();
      // this.loginService.resetPasswordDetails(forgotUserName)
      //   .then(this.forgotLoginDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    // } else {
    //   const forgotUserName = (this.login.forgotUserName)?.toLowerCase();
    //   this.loginService.resetPasswordDetails(forgotUserName)
    //     .then(this.forgotLoginDetailsSH.bind(this), this.forgotLoginDetailsFH.bind(this));
    // }
  }


  private forgotLoginDetailsSH() {
    this.toastr.success(LOGIN_UMS.login_password_mail, COMMON_UMS.SUCCESS);
    setTimeout(() => { this.cancelForgotPassword(); }, 1500);
  }

  private forgotLoginDetailsFH(res: any) {
    const errorMessage = (res.error && res.error.errorMessage) ? res.error.errorMessage : LOGIN_UMS.login_invalid_credentials;
    this.toastr.error(errorMessage, COMMON_UMS.ERROR, { enableHtml: true });
  }

  private getGlobalSettingsSH(res: any) {
    if (res) {
      localStorage.setItem('transLoad', "false");
      this.commonService.setTransState(localStorage.getItem('transLoad'));
      let dtObj, dateFormatObj;
      const dateObj = res.filter(function (resObj: any) {
        return (resObj.code == "DTFMT");
      });
      if (dateObj.length) {
        if (dateObj[0].value.split("/").length) {
          dtObj = dateObj[0].value.split("/");
        } else if (dateObj[0].value.split("-").length) {
          dtObj = dateObj[0].value.split("-");
        }
        const dateFormatArr = dtObj, cDateFormatArr: any = [];
        dateFormatArr.forEach(function (dtf: any) {
          cDateFormatArr.push(dtf.toUpperCase());
        });
        if (dateObj[0].value.split("/").length) {
          dateFormatObj = cDateFormatArr.join("/");
        } else {
          dateFormatObj = cDateFormatArr.join("-");
        }
        this.commonService.setDateFormat(dateFormatObj);
      }

      // call to get Home Meta Data
      this.getHomeMetaDetails();
      this.getGlobalMetadata();

      //VCE-27296
      this.getApplicationVersion();

      this.loginService.getUserProfileDetails()
        .then(this.getUserDetailsSH.bind(this), (error: any) => {
          this.zone.run(() => {
            this.router.navigateByUrl('\home');
          });
        });

      const companyCode = this.commonService.getCompanyCode();
      if (companyCode) {
        this.commonService.getCalendarDefinitionTabType(companyCode)
          .then(this.getCalendarDefinitionSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
      }
    } else {
      const errorMessage = (res.error && res.error.errorMessage) ? res.error.errorMessage : LOGIN_UMS.login_invalid_credentials;
      this.toastr.error(errorMessage, COMMON_UMS.ERROR, { enableHtml: true });
    }
  }

  private getGlobalSettingsFH(res: any) {
    this.login.password = '';
    this.login.code = '';
    const errorMessage = (res.error && res.error.errorMessage) ? res.error.errorMessage : LOGIN_UMS.login_invalid_credentials;
    this.toastr.error(errorMessage, COMMON_UMS.ERROR, { enableHtml: true });
    if (this.login.email) {
      this.validateUser(this.login.email);
    } else {
      console.error('Username is not available to call validateUser API.');
    }
  }

  // private getLoginDetailsSH(response: any) {
  //   const responseMsg = response;
  //   //if (responseMsg.success) {
  //   if (responseMsg) {
  //     this.loginService.getGlobalSettings(responseMsg);
  //     // call to get Home Meta Data
  //     this.getHomeMetaDetails();
  //     this.getGlobalMetadata();

  //     this.loginService.getUserProfileDetails()
  //       .then(this.getUserDetailsSH.bind(this), (error: any) => {
  //         this.router.navigateByUrl('\home');
  //       });

  //     const companyCode = this.commonService.getCompanyCode();
  //     if (companyCode) {
  //       this.commonService.getCalendarDefinition(companyCode)
  //         .then(this.getCalendarDefinitionSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  //     }
  //   } else {
  //     this.toastr.error(LOGIN_UMS.login_invalid_credentials, COMMON_UMS.ERROR);
  //   }
  // }

  private getCalendarDefinitionSH(res: any) {
    if (res) {
      this.timeZoneInfo = res.timeZone || 'America/Los_Angeles';
      this.commonService.setTimeZonInfo(this.timeZoneInfo);
    }
  }

  private getUserDetailsSH(response: any) {
    const responseMsg = response;
    if (responseMsg) {
      let langCode = 'en_us';
      this.commonService.setUserDetails(responseMsg);
      this.loginService.setUser(responseMsg);
      this.loginService.setTimeZoneBasedOnCalendarDefination();
      if (responseMsg.language && responseMsg.language.locale) {
        langCode = responseMsg.language.locale;
        if (langCode) {
          this.commonService.getTranslationsOfSelectedLanguage(langCode).then((res: any) => {
            this.commonService.setTranslatedObj(res);
          }, (err) => {
            this.commonService.commonErrorHandler(err);
            this.commonService.setTranslatedObj([]);
          });
        }
      }
      localStorage.setItem('userLanguage', langCode);
      this.commonService.loadTranslations();
      if (responseMsg.permissions && responseMsg.permissions.features) {
        this.formatFeaturePermissions(responseMsg.permissions.features);
      }
      if (responseMsg.permissions && responseMsg.permissions.menus) {
        this.prepareMenuObj(responseMsg.permissions.menus);
      }
      this.getHomePageMetaData();
    }
  }

  private getHomeMetaDetails() {
    this.commonService.getHomeMetaAPIData()
      .then(this.getHomeMetaDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getHomeMetaDetailsSH(response: any) {
    const responseMsg = response;
    if (responseMsg) {
      this.commonService.setHomeMetaDetails(responseMsg);
    }
  }

  private formatFeaturePermissions(features: any) {
    localStorage.setItem('featuresAvailable', '');
    const featuresAvailable: any = {};
    features.forEach((element: any, index: any) => {
      featuresAvailable[element.code] = true;
    });
    localStorage.setItem('featuresAvailable', JSON.stringify(featuresAvailable));
  }

  private prepareMenuObj(menus: any) {
    localStorage.setItem('MenuIds', '');
    const menuIds: any = {};
    menus.forEach((element: any) => {
      menuIds[element.code] = element.id;
    });
    localStorage.setItem('menuIds', JSON.stringify(menuIds));
  }

  public forgotPassword() {
    this.login.forgotUserName = '';
    this.forgotForm = true;
    this.zone.run(() => {
      this.router.navigateByUrl('/resetPassword');
    });
  }

  public cancelForgotPassword() {
    this.login.email = '';
    this.login.password = '';
    this.isformLogin = null;
    this.forgotForm = false;
    this.user = 'defaultUser';
    this.zone.run(() => {
      this.router.navigateByUrl('/login');
    });
  }

  //VCE-27296
  public getApplicationVersion() {
    this.loginService.getAppVersion().then((res: any) => {
      this.commonService.setAppVersion(res && res.appVersion);
    }, (err: any) => { })
  }
  //VCE-27296

  public openAboutModal() {
    this.loginService.getDeploymentAbout().then((res: any) => {
      this.modalService.show(AboutModalComponent, {
        initialState: { context: { data: res } },
        class: 'modal-dialog modal-custom-width'
      });
    }, (err: any) => {
      this.toastr.error(LOGIN_UMS.login_about_fetch_error, COMMON_UMS.ERROR, { enableHtml: true });
    });
  }
  /*  VCE:24069-Changes for MFA starts here
        Validating User email Id first according to response doing the needful redirection.
    */

  public validateUser(emailId: any) {
    if (emailId) {
      const pattern = new RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$');
      if (!pattern.test(emailId?.toLowerCase())) {
        this.email.error = LOGIN_UMS.login_invalid_email_format;
        return;
      } else {
        this.email.error = "";
      }
    }
    const authenicateObj: any = {};
    // fix to make sure case senstive issue of user name
    authenicateObj.emailId = (emailId).toLowerCase();
    this.commonService.validateUser(authenicateObj).then(
      (res) => this.validateUserSH(authenicateObj.emailId, res),
      this.validateUserFH.bind(this)
    );

  }

  private validateUserSH(emailId: string, res: any) {
    this.isformLogin = res.form;
    this.enableOtp = res.enableOtp;
    if (this.isformLogin === 'false') {
      const location = window.location,
        hostName = location.hostname,
        protocol = location.protocol,
        port = location.port;
      if (hostName === 'localhost' || hostName === '127.0.0.1') {
        /* For local development */
        window.location.href = protocol + '//' + hostName + ':8084' + '/oauth2/authorization/azure' + '?email=' + emailId;
      } else {
        /*  - For hosted env with ip address
        *   - port is defaulted to 80 incase not available
        */
        window.location.href = protocol + '//' + hostName + ':' + (port || '') + '/api/oauth2/authorization/azure' + '?email=' + emailId;
      }
    } else {
      this.router.navigateByUrl('/login');
    }
    this.login.email = (this.login.email).toLowerCase();
  }

  private validateUserFH(res: any) {
    res.error.errors.forEach((err: any) => {
      this.toastr.error(err.errorMessage, COMMON_UMS.ERROR, { enableHtml: true });
    })
    this.isformLogin = null;
  }

  // VCE:24069-Changes for MFA Ends here

}
